<template>
    <b-modal
        id="modal"
        v-model="mostrarModal"
        @show="preencherForm()"
        size="lg"
    >
        <div slot="modal-title">
            Penalidade -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label>Tipo da Penalidade</label>
                    <b-form-select
                        :options="tiposPenalidades"
                        v-model="tipoPenalidadeId"
                        text-field="descricao"
                        value-field="tipoPenalidadeId"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <!-- </b-row>
            <b-row>-->
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.dataPenalidade.$error ? false : null"
                    invalid-feedback="Data da penalidade é obrigatória"
                >
                    <label>Data da Penalidade</label>
                    <date-picker
                        v-model="dataPenalidade"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input.native="$v.dataPenalidade.$touch()"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Descrição</label>
                    <b-form-textarea
                        v-model="descricao"
                        :rows="6"
                        @input="$v.descricao.$touch()"
                        :state="$v.descricao.$error ? false : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                        >A descrição é obrigatória</b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.valorMulta.$error ? false : null"
                    invalid-feedback="Valor é obrigatório"
                >
                    <label>Valor da Multa</label>
                    <money
                        v-model="valorMulta"
                        v-bind="$moneyConfig"
                        class="form-control text-right"
                        @input.native="$v.valorMulta.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
            <!-- </b-row>
            <b-row>-->
            <b-col sm="12" md="6">
                <b-form-group>
                    <label>Recurso</label>
                    <b-form-select
                        :options="recursos"
                        v-model="recursoId"
                        text-field="descricao"
                        value-field="recursoId"
                        @input="$v.recursoId.$touch()"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import PenalidadesServicos from './PenalidadesServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        tipoOperacao: {
            type: String,
            default: () => ''
        },

        showModal: {
            type: Boolean,
            default: () => false
        },

        penalidadeId: {
            type: String,
            default: () => ''
        }
    },

    data() {
        return {
            mostrarModal: false,
            tiposPenalidades: [],
            recursos: [],
            erros: [],
            tipoPenalidadeId: null,
            dataPenalidade: new Date(),
            valorMulta: 0,
            descricao: '',
            recursoId: null
        }
    },

    methods: {
        obterTiposPenalidades() {
            this.$store.dispatch('addRequest')
            PenalidadesServicos.obterTiposPenalidades().then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposPenalidades = response.data
                        this.tipoPenalidadeId = this.tiposPenalidades[0].tipoPenalidadeId
                    } else {
                        this.$toast.error(
                            'Erro ao obter os tipos de penalidades',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterRecursos() {
            this.$store.dispatch('addRequest')
            PenalidadesServicos.obterRecursos().then(response => {
                if (response) {
                    if (response.success) {
                        this.recursos = response.data
                        this.recursoId = this.recursos[0].recursoId
                    } else {
                        this.$toast.error(
                            'Erro ao obter os recursos das penalidades',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterPenalidade() {
            this.$store.dispatch('addRequest')
            PenalidadesServicos.obterPenalidade(
                this.contrato.idContrato,
                this.penalidadeId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.tipoPenalidadeId = response.data.tipoPenalidadeId
                        this.dataPenalidade = this.$moment(
                            response.data.dataPenalidade
                        ).format('DD/MM/YYYY')
                        this.descricao = response.data.descricao
                        this.valorMulta = response.data.valorMulta
                        this.recursoId = response.data.recursoId
                    } else {
                        this.$toast.error(
                            'Erro ao obter a penalidade',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        fecharModal() {
            this.mostrarModal = false
            this.resetFormulario()
            this.$emit('modalFechado')
        },

        resetFormulario() {
            this.erros = []
            this.tipoPenalidadeId = null
            this.dataPenalidade = new Date()
            this.valorMulta = 0
            this.descricao = ''
            this.recursoId = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterTiposPenalidades()
            this.obterRecursos()
            if (this.tipoOperacao == 'a') {
                this.obterPenalidade()
            }
        },

        confirmarSalvar() {
            let msg
            if (this.tipoOperacao == 'i') {
                msg = 'Confirma a inserção da penalidade?'
            } else {
                msg = 'Confirma a atualização da penalidade?'
            }

            this.$swal({
                title: 'Penalidade do Contrato',
                html: msg,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let penalidadeDto = {
                contratoId: this.contrato.idContrato,
                tipoPenalidadeId: this.tipoPenalidadeId,
                dataPenalidade: this.$moment(this.dataPenalidade, 'DD/MM/YYYY'),
                descricao: this.descricao,
                valorMulta: this.valorMulta,
                recursoId: this.recursoId
            }

            if (this.tipoOperacao == 'a') {
                penalidadeDto.penalidadeId = this.penalidadeId
            }

            let promisse
            if (this.tipoOperacao == 'i') {
                promisse = PenalidadesServicos.inserir(penalidadeDto)
            } else {
                promisse = PenalidadesServicos.atualizar(penalidadeDto)
            }

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterPenalidadesAtualizadas')
            this.fecharModal()
        }
    },

    created() {},

    computed: {
        operacao() {
            switch (this.tipoOperacao) {
                case 'i':
                    return 'INSERIR'
                case 'a':
                    return 'ATUALIZAR'
                default:
                    break
            }
        },

        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {
        showModal() {
            this.mostrarModal = this.showModal
        }
    },

    validations: {
        tipoPenalidadeId: {
            required
        },
        dataPenalidade: {
            required
        },
        valorMulta: {
            required
        },
        descricao: {
            required
        },
        recursoId: {
            required
        }
    }
}
</script>
